export const INQUIRY_STATE:any = {"0":"준비중","1":"답변완료"};
